import { useEffect, useContext } from 'react';
import { ThemeContext } from '../Theme/ThemeProvider';
const GlobalStyle = () => {
    const theme = useContext(ThemeContext);
    useEffect(() => {
        import(`./styles/${theme}.scss`);
    }, []);
    return null;
};
export default GlobalStyle;
//# sourceMappingURL=GlobalStyle.js.map